<template>
   <v-container>
      <v-layout text-center wrap>
         <v-flex mb-4>
            <h1 class="display-3 font-weight-bold mb-3">
               Error en autenticación
            </h1>
            <p class="body-1 font-weight-regular">
               Para regresar a la página principal solo debes hacer clic en el
               siguiente botón.
            </p>
         </v-flex>

         <!-- Pista según el tipo de error -->
         <v-flex v-if="pista" xs12 class="mb-4">
            <v-alert
               color="primary"
               border="left"
               colored-border
               class="text-left mx-auto"
               max-width="600"
               elevation="1"
            >
               <span class="font-weight-medium">{{ pista }}</span>
            </v-alert>
         </v-flex>

         <!-- Detalle técnico del error -->
         <v-flex v-if="detalleError" xs12 class="mb-4">
            <v-expansion-panels class="mx-auto" style="max-width: 600px">
               <v-expansion-panel>
                  <v-expansion-panel-header>
                     Ver detalle técnico
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                     <pre
                        class="text-left"
                        style="
                           white-space: pre-wrap;
                           word-break: break-word;
                           font-size: 13px;
                        "
                        >{{ detalleError }}</pre
                     >
                  </v-expansion-panel-content>
               </v-expansion-panel>
            </v-expansion-panels>
         </v-flex>

         <v-flex xs12>
            <v-btn color="primary" @click="regresar">Regresar</v-btn>
         </v-flex>
      </v-layout>
   </v-container>
</template>

<script>
export default {
   name: 'OidcCallbackError',
   data: () => ({
      detalleError: ''
   }),
   computed: {
      // Interpreta el error para dar una pista accionable al usuario/soporte
      pista() {
         const e = (this.detalleError || '').toLowerCase()
         if (!e) return ''
         if (
            e.includes('iat') ||
            e.includes('exp') ||
            e.includes('nbf') ||
            e.includes('clock') ||
            e.includes('future') ||
            e.includes('expired') ||
            e.includes('not valid yet')
         ) {
            return 'Posible causa: la fecha y hora de este equipo están desincronizadas. Verifica que la fecha, hora y zona horaria sean correctas (activa la sincronización automática) y vuelve a intentar.'
         }
         if (e.includes('state') || e.includes('storage')) {
            return 'Posible causa: la sesión de inicio no se encontró en el navegador. Evita recargar o entrar por un enlace guardado de la pantalla de retorno; intenta en una ventana normal (no incógnito) y permite cookies y almacenamiento para este sitio.'
         }
         return ''
      }
   },
   created() {
      try {
         this.detalleError = sessionStorage.getItem('oidcCallbackError') || ''
      } catch (e) {
         this.detalleError = ''
      }
   },
   methods: {
      regresar() {
         try {
            sessionStorage.removeItem('oidcCallbackError')
         } catch (e) {
            // no-op
         }
         this.$router.push({ name: 'inicio' })
      }
   }
}
</script>
